import React from "react";
import { useStyles } from "./styles";

export type UserActionsProps = {
  onApply: () => void;
  onCancel: () => void;
  valid: boolean;
};

export const dataPrivacy: React.FC<UserActionsProps> = (props) => {
  const classes = useStyles(props);
  return (
    <>
      <div>
        <div className={classes.root}>
          <h3>
            Cookie List
          </h3>
          <div>
            A cookie is a small piece of data (text file) that a website – when visited by a user – asks your browser to store on your
            device in order to remember information about you, such as your language preference or login information. Those cookies are set
            by us and called first-party cookies. We also use third-party cookies – which are cookies from a domain different than the
            domain of the website you are visiting – for our advertising and marketing efforts. More specifically, we use cookies and other
            tracking technologies for the following purposes:
          </div>

          <section>
            <h4>Strictly Necessary Cookies</h4>
            <p>
              These cookies are necessary for the website to function. They are usually only set in response to actions made by you which
              amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your
              browser to block or alert you about these cookies, but this might cause some parts of the website to malfunction.{" "}
            </p>
            <section>
              <ul>
                <li>
                  <h5>Tealium</h5>
                  <p>
                    <p>
                      Through our service provider Tealium Inc, 11085 Torreyana Road, San Diego, CA, 92121 USA, we use Tealium iQ Tag
                      Management to assign tags to our websites and manage them. The tag manager can use the tags to specifically apply
                      analysis and tracking tools for us. The tag management system as such does not store any personal data about you. Only
                      anonymous data is generated, which is stored locally in the browser in the cookie "utag_main".
                    </p>
                    <p>
                      For further information about Tealium, go to{" "}
                      <a href="https://community.tealiumiq.com/t5/iQ-Tag-Management/Tealium-Cookies/ta-p/138/" rel="nofollow">
                        https://community.tealiumiq.com/t5/iQ-Tag-Management/Tealium-Cookies/ta-p/138/
                      </a>
                    </p>
                  </p>
                </li>
                <li>
                  <h5>Cookies from OneTrust, LLC.</h5>
                  <p>
                    <p>
                      As part of the cookie compliance module of our service provider, OneTrust Technology Limited, Dixon House 1 Lloyd´s
                      Avenue, London EC3N3DQ, UK, we use cookies to manage your preferences in the cookie settings.
                    </p>
                    <p>
                      For further information on OneTrust, go to{" "}
                      <a href="https://community.cookiepro.com/s/article/UUID-1e75fb0d-bb79-2af8-cb85-f905d16f1220" rel="nofollow">
                        https://community.cookiepro.com/s/article/UUID-1e75fb0d-bb79-2af8-cb85-f905d16f1220
                      </a>
                    </p>
                  </p>
                </li>
              </ul>
            </section>
          </section>
        </div>
      </div>
    </>
  );
};
